/**
 * Returns the season for a given date (string "YYYY-MM-DD" or Date object).
 * For dates in the second half of the year (September-December), returns the next year.
 * Example: The season for December 2022 is 2023.
 */
export function getSeason(dateInput) {
    let date = dateInput instanceof Date ? dateInput : new Date(dateInput)    
    let season = date.getFullYear()
    if (date.getMonth() > 7) { // Months are 0-indexed in JS, so add 1
        season += 1
    }
    return season
}


/**
 * Returns the current (or upcoming) season year.
 * Not the current calendar year, but returns the next year in the second half of the year.
 */
export function getCurrentSeason() {
    return getSeason(new Date())
}

export function getCurrentDate() {
    const date = new Date()
    return date.toISOString().split('T')[0]
}

/**
 * Formats a birthdate for display.
 * Handles both full dates (YYYY-MM-DD) and year-only values (YYYY).
 * @param {string} birthdate - The birthdate string
 * @param {object} moment - The moment.js instance
 * @returns {string} Formatted birthdate string
 */
export function formatBirthdate(birthdate, moment) {
    if (!birthdate) return ''
    // Year-only format (4 digits)
    if (/^\d{4}$/.test(birthdate)) {
        return `${birthdate}.`
    }
    // Full date format
    return moment(birthdate).format("Do MMMM YYYY.")
}

/**
 * Checks if a birthdate is in year-only format.
 * @param {string} birthdate - The birthdate string
 * @returns {boolean} True if year-only format
 */
export function isYearOnlyBirthdate(birthdate) {
    return !!(birthdate && /^\d{4}$/.test(birthdate))
}
